import styled from 'styled-components/macro';
import images from '~/constants/images';

export const GreenKeeperContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px 95px;
  align-items: center;
  background-color: ${({ theme }) => theme.white};

  &:before {
    content: ' ';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.2;
    background-image: url(${images.beat});
    background-repeat: no-repeat;
    background-position: center;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    padding: 30px 0 0;
    height: auto;
  }
`;

export const GrassImage = styled.div`
  width: 70%;
  height: 320px;
  display: flex;
  justify-content: space-around;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    justify-content: center;
    display: block;
    height: auto;
  }
`;

export const GrassImageColumn = styled.div`
  width: ${props => (!props.center ? '25%' : '50%')};
  height:320px;
  display:flex;
  align-items: ${props => (props.left ? 'flex-end' : 'flex-start')};
  position:relative;
  ${props => props.left && `justify-content:flex-end;`}
  ${props => props.center && `justify-content:center;`}
  ${props => props.right && `justify-content:flex-start;`}
  > div{
    height: ${props => (!props.center ? '200px' : '320px')};
  }
  .mark{
    width:200px;
    height:3px;
    z-index:5;
    position:absolute;
    ${props =>
      props.left ? 'bottom:170px;left:270px;' : 'top:30px;left:-220px;'}
    background-color:${props => props.theme.green};
  }

  img{
    z-index:0;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: ${props => (props.center || props.bottom ? '100%' : '50%')};
    height:  ${props => (props.center ? '190px' : 'auto')};
    float:left;
    padding:0 10px;
    ${({ center }) => center && 'align-items:center;'}

    > div{
      width:100%;
      height:auto;
    }
    .mark{
      ${props =>
        props.left
          ? 'width:3px;height:65px;position: absolute;top: -75px;left: 65%;'
          : 'width:3px;height:125px;position: absolute;top: -135px;left: 20%;'}
    }


    img{
      width:40vw;
      min-width:200px;
    }
  }
`;
